var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContractApplication"},[_vm._v(" 合同申请 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }